import React from 'react'
import { RowLayout } from '../RowLayout'
import { CaseTypeType, InsuranceDataType } from '../../models'
import { strToDateFormat } from '../../helpers'

import { translation } from '../../i18n'
import { OverviewSectionTitle } from './OverviewSectionTitle'

type InsuranceOverviewPropsType = {
  sectionLabelStyles: string
  caseType: CaseTypeType | null
  insuranceData?: InsuranceDataType
} & translation

export const InsuranceOverview = (props: InsuranceOverviewPropsType) => {
  const t = props.t
  return (
    <>
      <OverviewSectionTitle
        styles={props.sectionLabelStyles}
        titleName={t('sixthPg.overview.details')}
      />
      <RowLayout
        text={t('firstPg.policyNumber.label')}
        data={props.insuranceData?.policyNumber}
      />
      {props.caseType !== null && props.caseType !== 'TI' && (
        <React.Fragment>
          <RowLayout
            text={t('firstPg.firstName.label')}
            data={props.insuranceData?.firstName}
          />
          <RowLayout
            text={t('firstPg.lastName.label')}
            data={props.insuranceData?.lastName}
          />
          <RowLayout
            text={t('firstPg.birthDate.label')}
            data={strToDateFormat(props.insuranceData?.birthDate)}
          />
        </React.Fragment>
      )}
    </>
  )
}
